import { useGrowl } from "PFApp/use_growl";
import { Button } from "PFComponents/button";
import { FileUpload } from "PFComponents/file_upload";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { ApiRoute } from "PFCore/utilities/routes";
import { Id, LocalisationKeys } from "PFTypes";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import css from "../localisation_export.module.scss";

const TRANSLATABLE_TYPE = {
  [LocalisationKeys.CustomTypes]: "Attributes::CustomType",
  [LocalisationKeys.AccountTemplates]: "Activities::AccountTemplate",
  [LocalisationKeys.Filters]: "Activities::Filter"
};

type UploadFileProps = {
  accountId?: Id;
  localisationKey: LocalisationKeys;
  onExportModalOpen: () => void;
  onUpload: (uploadData) => void;
};

export const UploadFile = ({ accountId, localisationKey, onExportModalOpen, onUpload }: UploadFileProps) => {
  const { t } = useTranslation(["admin", "translation"]);
  const growl = useGrowl();

  const uploadRef = useRef<HTMLInputElement>();

  return (
    <section className={css.content}>
      <Icon name="import" size="xxxl" />
      <Typography variant="h4" noMargin>
        {t("admin:localisation.importModal.dropAreaHeader")}
      </Typography>
      <FileUpload
        inputRef={uploadRef}
        data={{
          translatable_type: TRANSLATABLE_TYPE[localisationKey] // eslint-disable-line camelcase
        }}
        name="csv"
        url={ApiRoute(`/api/saas_admin/accounts/${accountId}/localisation/localisation_imports`)}
        acceptMediaTypes={[".csv"]}
        allowedFileTypes={/\.csv$/i}
        handleLoad={onUpload}
        handleError={(message: string) => growl({ message })}
        handleNetworkError={() => onUpload(undefined)}
        showDraggingHint={false}
      >
        <Button
          text={t("admin:localisation.importModal.upload")}
          onClick={() => uploadRef.current?.click()}
        />
      </FileUpload>
      <Button
        kind="text"
        text={t("admin:localisation.importModal.downloadTemplate")}
        onClick={onExportModalOpen}
      />
    </section>
  );
};
